const domain = "https://api.samedayvet.com";
// const domain = "http://localhost:3001";

const globalVariables = { domain };
export default globalVariables;
